import { Menu } from "../views/Menu";

export const dateTFormat = (date: Date) => {
  function formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const paddedMonth = month.toString().padStart(2, "0");
    const paddedDay = day.toString().padStart(2, "0");
    const paddedHours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    const paddedSeconds = seconds.toString().padStart(2, "0");

    return `${year}-${paddedMonth}-${paddedDay}T${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
  }
  return formatDate(date);
};

export const getEmbedUrl = (url: string | undefined) => {
  if (!url) return "";
  const videoId = url.split("v=")[1]?.split("&")[0];
  return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
};

export const getStatusLabel = (status: string | undefined) => {
  switch (status) {
    case "Pending":
      return "Pending";
    case "AcceptedByCart":
      return "Accepted By Car...";
    case "ApprovedByRestaurant":
      return "Approved By Res...";
    case "Collecting":
      return "Collecting";
    case "Preparing":
      return "Preparing";
    case "ReadyAtKitchen":
      return "Ready At Kitche...";
    case "ArrivedAtCart":
      return "Arrived At Cart";
    case "PackingComplete":
      return "Packing Complete";
    case "Completed":
      return "Completed";
    case "InAppCart":
      return "In App Cart";
    case "IssuedByKitchen":
      return "Issued By Kitch...";
    default:
      return "Cancelled";
  }
};

export const getDeliveryStatusLabel = (status: string | undefined) => {
  switch (status) {
    case "Pending":
      return "Pending";
    case "PackingComplete":
      return "Packing Complete";
    case "Dispatched":
      return "Dispatched";
    case "OutForDelivery":
      return "Out For Delivery";
    case "Delivered":
      return "Delivered";
    default:
      return "Cancelled";
  }
};

// src/utils/availabilityUtils.ts

export const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const getCurrentDayIndex = (): number => {
  return new Date().getDay(); // Returns 0-6 (Sun-Sat)
};

export const isItemAvailableToday = (availableDays?: number[]): boolean => {
  if (!availableDays || availableDays.length === 0) return true;
  const today = getCurrentDayIndex();
  return availableDays.includes(today);
};

export const getAvailableDayNames = (availableDays?: number[]): string => {
  if (!availableDays || availableDays.length === 0) return "Every day";
  return availableDays.map(day => dayNames[day]).join(', ');
};

export const getCurrentDayName = (): string => {
  return dayNames[getCurrentDayIndex()];
};

// Add this utility function outside your component
export const sortMenusByAvailability = (menus: Menu[]) => {
  return [...menus]
    .filter(menu => menu.status === 'Active' && menu.isAvailable && menu.supportedApps?.includes('CustomerWeb'))
    .sort((a, b) => {
      const isAvailableNow = (menu: Menu) => {
        const [startTimeStr, endTimeStr] = menu.servingTime?.split('-') || [];
        if (!startTimeStr || !endTimeStr) return true; // Assume available if no time specified

        const now = new Date();
        const startTime = new Date();
        const endTime = new Date();

        const [startHours, startMinutes] = startTimeStr.split(':').map(Number);
        const [endHours, endMinutes] = endTimeStr.split(':').map(Number);

        startTime.setHours(startHours, startMinutes, 0, 0);
        endTime.setHours(endHours, endMinutes, 0, 0);

        return now >= startTime && now <= endTime;
      };

      const aAvailable = isAvailableNow(a);
      const bAvailable = isAvailableNow(b);

      if (aAvailable && !bAvailable) return -1;
      if (!aAvailable && bAvailable) return 1;
      return 0;
    });
};

// utils/timeSlotsUtils.ts
// utils/scheduleUtils.ts
// export const generateAvailableSchedule = (
//   servingTime: string | undefined,
//   availableDays: number[] | undefined
// ) => {
//   if (!servingTime || !availableDays) return { dates: [], slots: [] };

//   const [startTimeStr, endTimeStr] = servingTime.split('-');
//   const [startHour, startMinute] = startTimeStr.split(':').map(Number);
//   const [endHour, endMinute] = endTimeStr.split(':').map(Number);

//   // Generate available dates (today + next 6 days)
//   const dates: { day: string; date: string; weekday: string }[] = [];
//   const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

//   for (let i = 0; i < 7; i++) {
//     const date = new Date();
//     date.setDate(date.getDate() + i);
//     const dayIndex = date.getDay();

//     if (availableDays.includes(dayIndex)) {
//       dates.push({
//         day: weekdays[dayIndex],
//         date: date.toISOString().split('T')[0],
//         weekday: i === 0 ? 'Today' : i === 1 ? 'Tomorrow' : weekdays[dayIndex]
//       });
//     }
//   }

//   // Generate time slots (30-minute intervals)
//   const slots: string[] = [];
//   let currentHour = startHour;
//   let currentMinute = startMinute;

//   while (currentHour < endHour || (currentHour === endHour && currentMinute < endMinute)) {
//     const period = currentHour >= 12 ? 'PM' : 'AM';
//     const displayHour = currentHour > 12 ? currentHour - 12 : currentHour;

//     slots.push(
//       `${displayHour}:${currentMinute.toString().padStart(2, '0')} ${period} - ` +
//       `${(currentMinute + 30) >= 60 ? 
//         (currentHour + 1 > 12 ? currentHour + 1 - 12 : currentHour + 1) : 
//         displayHour}:${(currentMinute + 30) % 60 === 0 ? '00' : '30'} ${period}`
//     );

//     // Increment by 30 minutes
//     currentMinute += 30;
//     if (currentMinute >= 60) {
//       currentHour++;
//       currentMinute -= 60;
//     }
//   }

//   return { dates, slots };
// };

export const generateAvailableSchedule = (
  servingTime: string | undefined,
  availableDays: number[] | undefined,
  orderClosingTime: string = "10:00 PM",
  maxDaysToScheduleAhead: number = 7
) => {
  if (!servingTime || !availableDays) return { dates: [], slots: [] };

  // const [startTimeStr, endTimeStr] = servingTime.split('-');
  // const [startHour, startMinute] = startTimeStr.split(':').map(Number);
  // const [endHour, endMinute] = endTimeStr.split(':').map(Number);

  // Parse order closing time to Date object
  const now = new Date();
  const closingTimeDate = new Date();
  const [closingHour, closingMinPart] = orderClosingTime.split(':');
  const [closingMinute, closingPeriod] = closingMinPart.split(' ');

  let closingH = parseInt(closingHour);
  if (closingPeriod === 'PM' && closingH !== 12) closingH += 12;
  if (closingPeriod === 'AM' && closingH === 12) closingH = 0;

  closingTimeDate.setHours(closingH, parseInt(closingMinute), 0, 0);

  const dates: { day: string; date: string; weekday: string }[] = [];
  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  for (let i = 0; i < (maxDaysToScheduleAhead + 1); i++) {
    const date = new Date();
    date.setDate(date.getDate() + i);
    const dayIndex = date.getDay();

    const isToday = i === 0;
    const isClosingTimePassed = isToday && now >= closingTimeDate;

    if (availableDays.includes(dayIndex) && (!isToday || !isClosingTimePassed)) {
      dates.push({
        day: weekdays[dayIndex],
        date: date.toISOString().split('T')[0],
        weekday: isToday ? 'Today' : i === 1 ? 'Tomorrow' : weekdays[dayIndex]
      });
    }
  }

  // Generate 30-min time slots
  // const slots: string[] = [];
  // let currentHour = startHour;
  // let currentMinute = startMinute;

  // while (currentHour < endHour || (currentHour === endHour && currentMinute < endMinute)) {
  //   const endSlotHour = currentMinute + 30 >= 60 ? currentHour + 1 : currentHour;
  //   const endSlotMinute = (currentMinute + 30) % 60;

  //   const formatTime = (h: number, m: number) => {
  //     const suffix = h >= 12 ? 'PM' : 'AM';
  //     const displayHour = h % 12 === 0 ? 12 : h % 12;
  //     return `${displayHour}:${m.toString().padStart(2, '0')} ${suffix}`;
  //   };

  //   slots.push(`${formatTime(currentHour, currentMinute)} - ${formatTime(endSlotHour, endSlotMinute)}`);

  //   currentMinute += 30;
  //   if (currentMinute >= 60) {
  //     currentHour++;
  //     currentMinute -= 60;
  //   }
  // }
  const slots = [
    "12:00 PM - 12:30 PM",
    "12:30 PM - 1:00 PM", 
    "1:00 PM - 1:30 PM",
    "1:30 PM - 2:00 PM"
  ];

  return { dates, slots };
};

export const convertToISODateTime = (dateStr: string, timeStr: string): string => {
  // Convert time to 24-hour format
  const [time, modifier] = timeStr.split(' ');
  let [hours, minutes] = time.split(':');

  if (modifier === 'PM' && hours !== '12') {
    hours = String(parseInt(hours, 10) + 12);
  }
  if (modifier === 'AM' && hours === '12') {
    hours = '00';
  }

  // Create ISO string (UTC)
  const isoString = `${dateStr}T${hours.padStart(2, '0')}:${minutes}:00.000Z`;

  // Validate the format
  if (isNaN(Date.parse(isoString))) {
    console.error('Invalid date format generated:', isoString);
    return new Date().toISOString(); // Fallback to current time
  }

  return isoString;
};

export const getUserInitials = (fullName: string | undefined) => {
  if (!fullName) return 'US'; // Default if no name
  
  const names = fullName.split(' ');
  let initials = '';
  
  if (names.length > 0) {
    initials += names[0].charAt(0).toUpperCase();
  }
  
  if (names.length > 1) {
    initials += names[names.length - 1].charAt(0).toUpperCase();
  }
  
  return initials || 'US'; // Fallback if something went wrong
};

const API_BASE_COMPRESS_IMAGE_URL = process.env.REACT_APP_COMPRESS_IMAGE_URL || 'https://storage.googleapis.com/fooddelivery-7eac6.appspot.com/Restaurants';

export const validateProfilePhotoUrl = (photoUrl: string | undefined | null): string | null => {
  if (!photoUrl) return null;
  
  const isDefaultGoogleImage = /(=s96-c|googleusercontent\.com\/a\/default-user)/.test(photoUrl);
  
  return isDefaultGoogleImage ? null : photoUrl;
};

// export const getCompressedImageUrl = (
//   originalUrl: string, 
//   thumbnailSize: number = 256
// ): string => {
//   if (!originalUrl) return '';
  
//   try {
//     // Check if it's already a compressed URL
//     if (originalUrl.includes('thumb@')) {
//       return originalUrl;
//     }

//     // Extract the file name from the original URL
//     const urlParts = originalUrl.split('/');
//     const fileName = urlParts[urlParts.length - 1];
    
//     // Extract restaurant ID and path
//     const restaurantMatch = originalUrl.match(/Restaurants\/([^/]+)\/MenuItems/);
//     if (!restaurantMatch) {
//       return originalUrl; // Return original if pattern doesn't match
//     }
    
//     const restaurantId = restaurantMatch[1];
    
//     // Extract the UUID from filename (assuming format: uuid.jpg)
//     const fileNameWithoutExtension = fileName.split('.')[0];
//     const fileExtension = "webp";
//     // Construct compressed URL
//     const compressedUrl = `${API_BASE_COMPRESS_IMAGE_URL}/${restaurantId}/MenuItems/thumb@${thumbnailSize}_${fileNameWithoutExtension}.${fileExtension}`;

//     return compressedUrl;
//   } catch (error) {
//     console.warn('Failed to convert image URL:', error);
//     return originalUrl; // Fallback to original URL
//   }
// };
/**
 * Converts original image URL to compressed image URL
 * @param originalUrl - The original image URL
 * @param thumbnailSize - The thumbnail size (default: 256)
 * @returns Compressed image URL
 */

/**
 * Converts original image URL to compressed image URL
 * @param originalUrl - The original image URL
 * @param thumbnailSize - The thumbnail size (default: 256)
 * @returns Compressed image URL
 */
export const getCompressedImageUrl = (
  originalUrl: string, 
  thumbnailSize: number = 256
): string => {
  if (!originalUrl) return '';
  
  try {
    // Check if it's already a compressed URL
    if (originalUrl.includes('thumb@')) {
      return originalUrl;
    }

    // Parse the original URL to extract components
    const url = new URL(originalUrl);
    const pathSegments = url.pathname.split('/').filter(segment => segment.length > 0);
    
    // We need at least 3 segments: pathType/resourceId/subPath/filename
    if (pathSegments.length < 3) {
      return originalUrl; // Not enough path segments
    }

    // Extract the filename (last segment)
    const fileName = pathSegments[pathSegments.length - 1];
    
    // Extract file name without extension
    const fileNameWithoutExtension = fileName.split('.')[0];
    
    // Get all path segments except the filename
    const pathWithoutFilename = pathSegments.slice(1, -1).join('/');

    // Construct the compressed URL:
    // Base URL + path structure + modified filename
    const compressedUrl = `${API_BASE_COMPRESS_IMAGE_URL}/${pathWithoutFilename}/thumb@${thumbnailSize}_${fileNameWithoutExtension}.webp`;

    return compressedUrl;
  } catch (error) {
    console.warn('Failed to convert image URL:', error);
    return originalUrl; // Fallback to original URL
  }
};

/**
 * Get image URL with fallback options
 * @param originalUrl - The original image URL
 * @param defaultImage - Default/fallback image
 * @param thumbnailSize - Thumbnail size for compression
 * @returns Image URL with fallbacks
 */
export const getImageUrlWithFallback = (
  originalUrl: any,
  defaultImage: string,
  thumbnailSize: number = 256
): string => {
  // Handle array imageUrl (extract first element if it's a valid URL)
  if (Array.isArray(originalUrl)) {
    if (originalUrl.length > 0 && originalUrl[0] && typeof originalUrl[0] === 'string') {
      return getCompressedImageUrl(originalUrl[0], thumbnailSize);
    }
    console.warn('Image URL is an empty array, using default image');
    return defaultImage;
  }
  
  // Handle invalid URL cases: null, undefined, empty string, or non-string types
  if (!originalUrl || typeof originalUrl !== 'string' || originalUrl.trim() === '') {
    return defaultImage;
  }
  
  return getCompressedImageUrl(originalUrl, thumbnailSize);
};
export const formatFirestoreTimestamp = (timestamp: any): string => {
  if (!timestamp) {
    const now = new Date();
    return now.toLocaleDateString('en-GB');
  }

  try {
    let date: Date;

    if (timestamp.seconds) {
      date = new Date(timestamp.seconds * 1000);
    } else {
      date = new Date(timestamp);
    }

    // Format: 24/09/2025
    return date.toLocaleDateString('en-GB');
  } catch (error) {
    console.error('Error formatting timestamp:', error);
    const now = new Date();
    return now.toLocaleDateString('en-GB');
  }
};
